
import React from "react";
import Link from "next/link";
import { IoChevronDown } from "react-icons/io5";
import { MobileDropDown } from "./MobileDropDown";
export const MobileMenu = ({ lightHeader, isSticky }) => {
	return (
		<div className={`flex items-center xl:hidden h-[40px] w-[40px] justify-center border-[1.5px] ${!lightHeader || isSticky ? "border-text" : " border-white"} rounded-[40px]`} htmlFor="mobile-menu">
			<label className="relative z-[9999] cursor-pointer">
				<input className="peer hidden" type="checkbox" id="mobile-menu" />
				<div className={`${!lightHeader || isSticky ? "bg-text before:bg-text after:bg-text" : "bg-white before:bg-white after:bg-white"}  h-[2px] content-[''] relative w-4 z-[10000] before:peer-checked:transform before:peer-checked:rotate-45 before:peer-checked:top-0 before:peer-checked:w-full after:peer-checked:transform after:peer-checked:-rotate-45   before:peer-checked:bg-text  after:peer-checked:bg-text after:peer-checked:bottom-0 after:peer-checked:w-full before:block before:h-full before:w-full before:absolute before:content-[''] before:transition-all before:ease-out before:duration-200 before:top-[-0.35rem] before:z-[10000] after:block after:h-full after:w-full after:right-0 after:absolute after:content-[''] after:transition-all after:ease-out after:duration-200 after:bottom-[-0.35rem] flex items-center  `}></div>
				<div className="fixed inset-0 z-[9999] hidden h-full w-full bg-text/50 backdrop-blur-sm peer-checked:block"></div>
				<div className="fixed top-0 right-0 z-[9999] h-full w-full translate-x-full overflow-y-auto overscroll-y-none transition duration-500 peer-checked:translate-x-0 peer-checked:shadow-heading">
					<div className="float-right min-h-full w-full max-w-[320px] bg-white px-6 pt-12 shadow-2xl">
						<menu className="mt-8 mb-8 flex flex-col space-y-4 text-heading text-text text-[16px] font-medium">
							<MobileDropDown title="Company">
								<div className="flex flex-col gap-2 text-[16px] font-normal ">
									<Link href="/about">About Us</Link>
									<Link href="/leadership">Leadership</Link>
									<Link href="/corporate-governance">Corporate Governance</Link>
								</div>
							</MobileDropDown>

							<MobileDropDown title="Our Businesses">
								<ul className="flex flex-col gap-2 text-[16px] font-normal ">
									<li><Link href="/business/thermal-power">Transitional Energy</Link></li>
									<li><Link href="/business/renewable">Renewable Energy</Link></li>
									<li><Link href="/business/mining">Mining Operations</Link></li>
								</ul>
							</MobileDropDown>

							<MobileDropDown title="Sustainability">
								<div className="flex flex-col gap-2 text-[16px] font-normal ">
									<Link href="/sustainability">Environment</Link>
									<Link href="/csr">Community &amp; CSR</Link>
								</div>
							</MobileDropDown>

							<MobileDropDown title="Media Center">
								<div className="flex flex-col gap-2 text-[16px] font-normal ">
									<Link href="/awards">Award</Link>
									<Link href="/media-coverage">Media Coverage</Link>
									<Link href="/news-release">News Releases</Link>
									<Link href="/media-kit">Media Kit</Link>
									<Link href="/thought-leadership">Thought Leadership</Link>
								</div>
							</MobileDropDown>

							<Link href="/life-at-hindustan-power">Careers</Link>
							<Link href="/tenders">Tenders</Link>
							<Link href="/contact-us">Contact</Link>
						</menu>
					</div>
				</div>
			</label>
		</div>
	);
};
